import { ReactNode } from "react";

import { Container } from "@mui/material";

import { Background } from "@baseComponents/Background";
import Footer from "@components/footer";
import { Menu } from "@components/menu";
import { PageMetadata, PageMetadataProps } from "@components/PageMetadata";

import { MDXStyles } from "./styles.styled";

interface ContactLayoutProps extends PageMetadataProps {
  children?: ReactNode;
}

function ContactLayoutBody({
  children,
  title,
  description,
}: ContactLayoutProps) {
  return (
    <>
      <PageMetadata title={title} description={description} />

      <Background />

      <Menu />

      <Container maxWidth="desktopXl">
        <MDXStyles>{children}</MDXStyles>
      </Container>

      <Footer />
    </>
  );
}

export const ContactLayout = ({ children, ...rest }: ContactLayoutProps) => {
  return <ContactLayoutBody {...rest}>{children}</ContactLayoutBody>;
};
